export function getItineraryType(tripType) {
  const itineraryType = {
    OW: 'ONE_WAY',
    RT: 'ROUND_TRIP',
    MD: 'MULTI_DESTINATION',
  }

  return itineraryType[tripType]
}

//  TODO: move to it's own util function
export function getPassengerInfo({ params }) {
  const { adults, children, infants, childAges } = buildPassengerInfo({ params })

  return {
    adults,
    children,
    infants,
    childAges,
  }
}

export function buildPassengerInfo({ params }) {
  return {
    adults: getNumOfPassengers(params['num-adults']) || 1,
    children: getNumOfPassengers(params['num-children']) || 0,
    infants: getNumOfPassengers(params['num-infants']) || 0,
    childAges: params['childAges'] || '',
  }
}

export function getNumOfPassengers(passengerType) {
  if (passengerType && !isNaN(Number(passengerType))) {
    return Number(passengerType)
  }

  return 0
}
